import Typography from '@eduzz/houston-ui/Typography';
import { Grid } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import React from 'react';
import { useObservable } from 'react-use-observable';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import affiliateService from 'v2/services/affiliate';

import { Export } from './Export';
import { useStyles } from './styles';

const Details = () => {
  const classes = useStyles();

  const [totalItems] = useObservable(() => affiliateService.getTotalItems(), []);
  const [loading] = useObservable(() => affiliateService.isLoading(), []);

  if (loading) return null;

  return (
    <>
      <div className={classes.root} id='affiliates-details'>
        <Grid className={classes.gridContainer} container alignItems='center'>
          <Grid item>
            <ListItem>
              <Typography id='affiliates-result-button-label' data-testid='affiliates-result-label' weight='semibold'>
                {totalItems || 0} solicitações
              </Typography>
            </ListItem>
          </Grid>
          <PermissionHide action={'myeduzz:meus-afiliados:editar'}>
            <Grid item style={{ marginLeft: 'auto' }}>
              <Export />
            </Grid>
          </PermissionHide>
        </Grid>
      </div>
    </>
  );
};

export default Details;
